module.exports = __webpack_public_path__ + "3f42d707252f079f2b99a157212b5c1a.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/Carroussel/widget/DDD.png
// module id = 196
// module chunks = 0